import { Component, Input } from '@angular/core';
import { Pipeline } from 'src/app/models/pipeline.model';
import { CategorizerLabelComponent } from '../categorizer-label/categorizer-label.component';
import { MapperLabelComponent } from '../mapper-label/mapper-label.component';
import { CodeSystemLabelComponent } from '../code-system-label/code-system-label.component';

@Component({
    selector: 'app-pipeline-detail',
    templateUrl: './pipeline-detail.component.html',
    styleUrls: ['./pipeline-detail.component.scss'],
    imports: [CategorizerLabelComponent, MapperLabelComponent, CodeSystemLabelComponent]
})
export class PipelineDetailComponent {

  @Input()
  public pipeline: Pipeline;

}
